/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UpdateProcedureDiagnosisCodeHoldingViewModel {
  id?: string;
  datasetId?: string;
  batchId?: string;
  sendingFacilityId?: string | null;
  procedureTransactionHoldingId?: string;
  diagnosisCodeId?: string | null;
  diagnosisCodeLinkId?: string | null;
  sequence?: number;
  isDeleted?: boolean;
}
